export var Labels;
(function (Labels) {
    Labels["SERVICE"] = "service";
    Labels["COMPONENT"] = "component";
    Labels["DB_INSTANCE"] = "db.instance";
    Labels["DB_STATEMENT"] = "db.statement";
    Labels["DB_TYPE"] = "db.type";
    Labels["DB_USER"] = "db.user";
    Labels["ERROR"] = "error";
    Labels["ERROR_KIND"] = "error.kind";
    Labels["ERROR_OBJECT"] = "error.object";
    Labels["ERROR_STACK"] = "stack";
    Labels["HTTP_METHOD"] = "http.method";
    Labels["HTTP_STATUS_CODE"] = "http.status_code";
    Labels["HTTP_URL"] = "http.url";
    Labels["MESSAGE_BUS_DESTINATION"] = "message_bus.destination";
    Labels["PEER_ADDRESS"] = "peer.address";
    Labels["PEER_HOSTNAME"] = "peer.hostname";
    Labels["PEER_IPV4"] = "peer.ipv4";
    Labels["PEER_IPV6"] = "peer.ipv6";
    Labels["PEER_PORT"] = "peer.port";
    Labels["PEER_SERVICE"] = "peer.service";
    Labels["SAMPLING_PRIORITY"] = "sampling.priority";
    Labels["SPAN_KIND"] = "span.kind";
    Labels["DB_STATEMENT_SUMMARY"] = "db.statement.summary";
    Labels["HTTP_PATH"] = "http.path";
    Labels["HTTP_FULLPATH"] = "http.full_path";
    Labels["HTTP_USER_AGENT"] = "http.user_agent";
    Labels["HTTP_REQUEST_SIZE"] = "http.request.size";
    Labels["HTTP_HEADERS"] = "http.headers";
    Labels["HTTP_REQUEST_PROTOCOL"] = "http.request.protocol";
    Labels["HTTP_REQUEST_QUERY"] = "http.request.query";
    Labels["RPC_METHOD"] = "rpc.method";
    Labels["RPC_TYPE"] = "rpc.type";
    Labels["PLUGIN_NAME"] = "plugin.name";
    Labels["RESOURCETYPE_NAME"] = "resource_type.name";
    Labels["NODE_NAME"] = "node.name";
    Labels["OP_CODE"] = "neo.op.code";
    Labels["NEO_ADDRESS"] = "neo.address";
    Labels["NODE_OPTIONSPATH"] = "node.options_path";
    Labels["NEO_TRANSACTION_HASH"] = "neo.transaction.hash";
    Labels["NEO_TRANSACTION_TYPE"] = "neo.transaction.type";
    Labels["NEO_TRANSACTION_FOUND"] = "neo.transaction.found";
    Labels["NEO_CONSENSUS_HASH"] = "neo.consensus.hash";
    Labels["NEO_BLOCK_INDEX"] = "neo.block.index";
    Labels["CALL_METHOD"] = "call.method";
    Labels["INVOKE_METHOD"] = "invoke.method";
    Labels["INVOKE_RAW_METHOD"] = "invoke_raw.method";
    Labels["JSONRPC_TYPE"] = "jsonrpc.type";
    Labels["COMMAND_NAME"] = "command.name";
})(Labels || (Labels = {}));

//# sourceMappingURL=labels.js.map
